export default __webpack_public_path__ + "static/color-analysis-hero-c2cb2ac2a561857c83505916a9df42fb.jpg";